import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { forgot_password } from "../../api/apiHandler";
import { TOAST_ERROR, TOAST_SUCCESS } from "../../utils/common.service";
export default function ForgotPassword({ isLoader }) {
  const navigate = useNavigate();

  const schema = yup.object().shape({
    // email: yup.string().required("Please enter email").matches(/^[a-zA-Z0-9]+([._-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9]+([.-]?[a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/, "Please enter valid email"),
    email: yup.string().required("Please enter email").matches(/^[a-zA-Z0-9]+([._-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9]+([.-]?[a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/, "Please enter valid email"),
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = (data) => {
    isLoader(true)
    forgot_password({ email: data.email }).then((res) => {
      isLoader(false)
      if (res.code == 1) {
        TOAST_SUCCESS(res.message);
        reset();
        // navigate(`/reset-password?token=${encodeURIComponent(res.data?.forgot_token)}`);
      } else {
        TOAST_ERROR(res.message);
      }
    });
  };

  return (
    <>
      <div>
        <main>
          <div className="login_sec">
            <div className="container-fluid d-flex justify-content-center align-items-center">
              <div
                className="row d-flex justify-content-center align-items-center"
                style={{ width: "80vw", height: "90vh" }}
              >
                <div
                  className="login-main-div col-lg-6 right"
                  style={{
                    backgroundColor: "rgb(240, 240, 240)",
                    boxShadow: "rgba(0, 0, 0, 0.20) 0px 5px 15px",
                    borderRadius: "20px",
                  }}
                >
                  <div className="btm_div form-section">
                    <div className="d-flex justify-content-center flex-column">
                      <p className="mb-2 mt-3 text-center poppins fs-2 fw-600 text-purple">
                        Forgot Password
                      </p>
                      <p className="text-center text-gray fs-6 mb-4">
                        Enter your email address to reset your password.
                      </p>
                    </div>

                    <form
                      onSubmit={handleSubmit(onSubmit)}
                      className="custom_form mt-4"
                    >
                      <div className="form-group mb-4">
                        <label className="mb-2">Email Address</label>
                        <input
                          type="email"
                          {...register("email")}
                          className="form-control"
                          placeholder=""
                        />
                        <p className="mt-2 font-bold col-red">
                          <span style={{ color: "red" }}>
                            {errors.email?.message}
                          </span>
                        </p>
                      </div>

                      <div className="mt-5 d-flex justify-content-center align-items-center">
                        <button
                          type="submit"
                          className="px-4 py-2 btn-theme bg-yellow text-center fw-600 d-block"
                        >
                          Send Reset Link
                        </button>
                      </div>

                      <div className="text-center mt-3">
                        <span
                          onClick={() => navigate("/login")}
                          className="text-decoration-underline text-purple fs-6"
                          style={{ cursor: "pointer" }}
                        >
                          Back to Login
                        </span>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>

    </>
  );
}
